const API_BASE_URL = 'https://vvcontest.revolutiontravel.ca:7979/api';

export const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/auth/login`,
  REGISTER: `${API_BASE_URL}/auth/register`,
  CHECK_EMAIL: `${API_BASE_URL}/auth/check-email`,
  RESET_PASSWORD: `${API_BASE_URL}/auth/reset-password`,
};

export default API_BASE_URL; 